import React, { FC } from 'react';
import { Card, CardContent, CardHeader, IconButton, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { InfoIcon, LightTooltip } from '../../../../../components';

interface Props {
  title: string;
  tooltip?: string;
  value: number;
  percentage: number;
  translation: any;
}

export const QuickReportWithPercentage: FC<Props> = ({ title, tooltip, value }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        action={
          tooltip && (
            <LightTooltip title={tooltip} arrow placement="right-start">
              <IconButton size="small">
                <InfoIcon />
              </IconButton>
            </LightTooltip>
          )
        }
        title={title}
      />
      <CardContent>
        <Typography component="p" className={classes.percentContent}>
          {value}
        </Typography>
        {/* <Grid className={classes.bottomContent}>{`${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`}</Grid> */}
      </CardContent>
    </Card>
  );
};
